export function CompassStar({ className = "h-4 w-4", ...p }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.4} strokeLinejoin="round" className={className} data-icon="compass-star" {...p}>
      <path d="M12 1.5 13.6 10.4 22.5 12 13.6 13.6 12 22.5 10.4 13.6 1.5 12 10.4 10.4Z" fill="currentColor" fillOpacity="0.18" />
      <path d="M12 6.5 14.6 12 12 17.5 9.4 12Z" fill="currentColor" stroke="none" />
      <path d="M5.6 5.6 10.6 10.6M18.4 5.6 13.4 10.6M5.6 18.4 10.6 13.4M18.4 18.4 13.4 13.4" strokeWidth={1.1} />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}
